/*
*###############################################################################
*Module Name                   : VoucherSellContent.js                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 6th 2022, 9:51:53 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from "react"
import {
  CardText,
  Col,
  Row,
  Alert,
  Button
} from "reactstrap"

import DPTextBox from "framework/components/DPTextBox"
import DPDropDown from "framework/components/DPDropDown"
import { fetchPriceModeData, getCustomerData, getSaleAssistantData } from "./VoucherSellController"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPTextBoxTow from "framework/components/DPTextBoxTow"
import DPSearchBoxDynamicHeadOffice from "framework/components/DPSearchBoxDynamicHeadOffice"


const VoucherSellContent = ({
  Gen_DataSearch,
  AlertColor,
  AlertMsg,
  show,
  Gen_Code,
  Gen_Code_OnChange,
  Gen_Code_onBlur,
  Gen_Code_Enabled,
  Gen_FromLocation,
  Gen_FromLocation_OnChange,
  Gen_ToLocation,

  Gen_TxnDate,
  Gen_TxnDate_OnChange,
  Gen_TxnDate_Enabled,

  SearchDefaultSorted,
  SearchModelOpen,
  SearchModelTrigger,
  SearchGetSelectRow,
  SearchDefaultSortedMain,
  SearchModelOpenMain,
  SearchModelTriggerMain,
  SearchGetSelectRowMain,
  Gen_mainSearchEnabled,
  menuCode,
  LocationCode,
  model_xlarge_locTo,
  model_xlarge_locFrom,
  tox_xlarge_locTo,
  tox_xlarge_locFrom,
  locationOnblurFrom,
  locationDescFrom,
  GetSelectRowLocFrom,
  GetSelectRowlOCTo,

  setAlertShow,
  setAlertMsg,
  setAlertColor,
  menuName,
  setSalesAssistName,
  setSalesAssist,
  setCustomerName,
  setCustomerCode,
  salesAssistName,
  salesAssist,
  customerName,
  customerCode,
  setPriceMode,
  priceMode,
  disableSalesAssist,
  disableCustomer,
  setDisableSalesAssist,
  setDisableCustomer,
}) => {


  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')

  const ApiURL = window.Links.ApiURL

  const [customerToggle, setCustomerToggle] = useState(false)
  const [salesAssistToggle, setSalesAssistToggle] = useState(false)
  const [priceModeList, setPriceModeList] = useState([])


  useEffect(async () => {
    setPriceModeList(await fetchPriceModeData())
  }, [])

  function toggleCustomer() {
    setCustomerToggle(!customerToggle)
  }

  function toggleSalesAssist() {
    setSalesAssistToggle(!salesAssistToggle)
  }

  async function handleCustomerData(customerData) {
    if (customerData.length > 0) {
      setCustomerName(customerData[0].strFullName);
      setCustomerCode(customerData[0].strCode);
      setDisableCustomer(true);
    } else {
      setAlertShow(true);
      setAlertMsg("Customer Not Found");
      setAlertColor("danger");
      setCustomerName("");
      setCustomerCode("");
      setTimeout(() => {
        setAlertShow(false);
      }, 3000);
    }
  }

  async function handleSaleAssitantData(saleAssistantData) {
    if (saleAssistantData.length > 0) {
      setSalesAssist(saleAssistantData[0].code);
      setSalesAssistName(saleAssistantData[0].fullName);
      setDisableSalesAssist(true);
    } else {
      setAlertShow(true);
      setAlertMsg("Sales Assistant Not Found");
      setAlertColor("danger");
      setSalesAssist("");
      setSalesAssistName("");
      setTimeout(() => {
        setAlertShow(false);
      }, 3000);
    }
  }


  async function getSelectedCustomer(e, row, isSelect, rowIndex) {
    const customerData = await getCustomerData(row.CM_CODE);
    await handleCustomerData(customerData);
    toggleCustomer();
  }

  async function getCustomerOnBlur(code) {
    const customerData = await getCustomerData(code);
    await handleCustomerData(customerData);
  }



  async function getSelectedSalesAssist(e, row, isSelect, rowIndex) {
    const salesAssistData = await getSaleAssistantData(row.SA_CODE);
    await handleSaleAssitantData(salesAssistData);
    toggleSalesAssist()
  }

  async function getSalesAssistOnBlur(code) {
    const salesAssistData = await getSaleAssistantData(code);
    await handleSaleAssitantData(salesAssistData);
  }


  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                </Alert>
              ) : null}
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Document No"
                      textType="text"
                      maxLength="13"
                      value={Gen_Code}
                      onChange={Gen_Code_OnChange}
                      disabled={Gen_Code_Enabled}
                      onBlur={Gen_Code_onBlur}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_DataSearch}
                      color="success"
                      className="btn-sm"
                      disabled={Gen_mainSearchEnabled}
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBoxTow
                      labelText="From Location"
                      disabled1={true}
                      disabled2={true}
                      value1={Gen_FromLocation}
                      value2={locationDescFrom}
                      onChange1={Gen_FromLocation_OnChange}
                      onBlur1={locationOnblurFrom}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    {/* <Button
                      onClick={tox_xlarge_locFrom}
                      color="success"
                      className="btn-sm"
                      disabled={locationFromDisable}
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBoxTow
                      labelText="Sales By"
                      disabled1={disableSalesAssist}
                      disabled2={true}
                      value1={salesAssist}
                      value2={salesAssistName}
                      onChange1={(e) => {
                        setSalesAssist(e.target.value)
                      }}
                      onBlur1={(e) => {
                        getSalesAssistOnBlur(e.target.value)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={toggleSalesAssist}
                      color="success"
                      className="btn-sm"
                      disabled={disableSalesAssist}
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Remarks 1"
                      textType="text"
                      maxLength="50"
                      value={Gen_Remark1}
                      onChange={Gen_Remark1_OnChange}
                      disabled={Gen_Remark1_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row> */}
              </Col>
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Date"
                      textType="date"
                      value={Gen_TxnDate}
                      onChange={Gen_TxnDate_OnChange}
                      disabled={Gen_TxnDate_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">

                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBoxTow
                      labelText="Customer"
                      disabled1={disableCustomer}
                      disabled2={true}
                      value1={customerCode}
                      value2={customerName}
                      onChange1={(e) => {
                        setCustomerCode(e.target.value)
                      }}
                      onBlur1={(e) => {
                        getCustomerOnBlur(e.target.value)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={toggleCustomer}
                      color="success"
                      className="btn-sm"
                      disabled={disableCustomer}
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPDropDown
                      disabled={Gen_TxnDate_Enabled}
                      labelText={"Price Mode"}
                      optionGroup={priceModeList}
                      selectedGroup={priceMode}
                      onChange={(e) => {
                        setPriceMode(e["value"])
                      }}

                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
            </Row>
          </CardText>
        </Col>


        <DPSearchBoxDynamicHeadOffice
          searchData={Datatablesub}
          columns={[]}
          defaultSorted={SearchDefaultSorted}
          mainTitle={menuName + " Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpen}
          toggle={SearchModelTrigger}
          getSelect={SearchGetSelectRow}
          APIURL={ApiURL}
          URLPath={"DOCUMENT"}
          MenuCode={menuCode}
          KeyVal={'DOC'}
          searchBy={'INVHED_INVNO'}
          FilterStr={`AND INVHED_LOCCODE = ${Gen_ToLocation}`}
        />

        <DPSearchBoxDynamicHeadOffice
          searchData={Datatablesub}
          columns={[]}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={menuName + " Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenMain}
          toggle={SearchModelTriggerMain}
          getSelect={SearchGetSelectRowMain}
          APIURL={ApiURL}
          URLPath={"DOCUMENT"}
          MenuCode={menuCode}
          KeyVal={'DOC'}
          searchBy={'INVHED_INVNO'}
          FilterStr={`AND INVHED_LOCCODE = ${LocationCode}`}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={[]}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Supplier Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_locFrom}
          toggle={tox_xlarge_locFrom}
          getSelect={GetSelectRowLocFrom}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={'LOC'}
          searchBy={'LOC_CODE'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={[]}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Location Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_locTo}
          toggle={tox_xlarge_locTo}
          getSelect={GetSelectRowlOCTo}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={'LOC'}
          searchBy={'LOC_CODE'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamicHeadOffice
          searchData={Datatablesub}
          columns={[]}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Customer Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={customerToggle}
          toggle={toggleCustomer}
          getSelect={getSelectedCustomer}
          APIURL={ApiURL}
          URLPath={"CUSTOMER"}
          MenuCode={menuCode}
          KeyVal={'CUS'}
          searchBy={'CM_CODE'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={[]}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Sales Assistant Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={salesAssistToggle}
          toggle={toggleSalesAssist}
          getSelect={getSelectedSalesAssist}
          APIURL={ApiURL}
          URLPath={"SALEEXE"}
          MenuCode={menuCode}
          KeyVal={'EXE'}
          searchBy={'SA_CODE'}
          FilterStr={groupFilter}
        />

      </div>
    </React.Fragment>
  )
}
export default VoucherSellContent
